export function stickyFooter() {
  const ctaBar = document.getElementById("footer-bar");
  // Der Schwellenwert (in Pixeln) für das Einblenden der Leiste
  const scrollThreshold = 100;

  // Funktion zur Überprüfung der Scroll-Position
  function checkScrollPosition() {
    // window.scrollY ist die aktuelle vertikale Scroll-Position in Pixeln
    const currentScrollY = window.scrollY;

    if (currentScrollY > scrollThreshold) {
      // Wenn der Schwellenwert überschritten ist, blende die Leiste ein
      ctaBar.classList.remove("inactive");
      ctaBar.classList.add("active");
    } else {
      // Wenn der Schwellenwert nicht überschritten ist (d.h. man ist oben),
      // blende die Leiste aus
      ctaBar.classList.remove("active");
      ctaBar.classList.add("inactive");
    }
  }

  // Füge den Event Listener zum 'scroll' Ereignis des Fensters hinzu
  window.addEventListener("scroll", checkScrollPosition);

  // Führe die Funktion einmal beim Laden der Seite aus
  checkScrollPosition();
}
